import {AnswerInterface} from '@modules/activities/core/models/answer.interface';

export interface AnswersContent {
    id: string | number;
    answer_text?: string;
    answers: AnswerInterface[];
    answers_app?: AnswerInterface[];
}